import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  data: [],
  pages: {
    pageNo: 1,
    totalPages: 1,
    pageSize: 10,
    totalElements: 5
  }
};

const AgencyAllocationUploadHistorySlice = createSlice({
  name: 'uploadHistory',
  initialState,
  reducers: {
    setUploadHistory(state, action) {
      return action.payload;
    }
  }
});

export const { setUploadHistory } = AgencyAllocationUploadHistorySlice.actions;

export default AgencyAllocationUploadHistorySlice.reducer;
